import { ErrorBoundary } from 'react-error-boundary';
import { Navigate } from 'react-router';
import ErrorFallback from 'src/components/error-fallback/ErrorFallbackDialog';
import { FC } from 'react';
import { usePermissionsContext } from 'src/components/permissions/PermissionsContext';
import { Tier } from 'src/generated/graphql';
import useGetUrlParam from 'src/hooks/useGetUrlParam';
import PrivateRoute from './PrivateRoute';
import { isAllowedRedirectUrl, isPage } from './helpers';

interface PublicRouteProps {
  component: FC;
  shouldRedirect?: boolean;
}

export default function PublicRoute({
  component: Component,
  shouldRedirect = true,
  ...props
}: PublicRouteProps) {
  const redirectUrl = useGetUrlParam('redirect');
  const { permissions } = usePermissionsContext();

  if (!isPage(['/signup', '/demo']) && permissions && permissions?.tier !== Tier.None) {
    if (redirectUrl) {
      if (isAllowedRedirectUrl(redirectUrl)) {
        window.location.replace(redirectUrl);
        return null;
      }

      // eslint-disable-next-line no-console
      console.warn(`Invalid redirectUrl ${redirectUrl}`);
    }

    if (shouldRedirect) {
      return <Navigate to="/" />;
    }

    return <PrivateRoute component={Component} />;
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Component {...props} />
    </ErrorBoundary>
  );
}
